import { getHashOfString } from "../../../../hooks/useGetAvatarColor/useGetAvatarColor";
import { BuildingType } from "../../../Plants/Buildings/P_Building";



export function getBuildingColor(theme: any,buildingType: BuildingType | undefined, name: string ) {
    const bColors = getBuildingTypeColors(buildingType,theme);
    const color = bColors ? bColors[getHashOfString(name) % bColors?.length] : theme.colors.negative;
    return color;
}

export function getBuildingTypeColor(buildingType: BuildingType | undefined, theme: any) {
    if (buildingType === undefined) 
        return colorsPrimary(theme);

    switch(buildingType) {
        case BuildingType.Office: return theme.colors.accent;
        case BuildingType.Hotel: return theme.colors.warning;
        case BuildingType.AssistedLiving: return theme.colors.warning300;
        case BuildingType.Living: return theme.colors.warning600;
        

        case BuildingType.Educational: return theme.colors.positive;
        case BuildingType.ShoppingMall: return theme.colors.negative;
        case BuildingType.EventHalls: return theme.colors.negative;
        case BuildingType.Hospital: return theme.colors.negative;
        case BuildingType.Assembly: return theme.colors.primary;
        
        default: return theme.colors.primary;
    }
}


function getBuildingTypeColors(buildingType: BuildingType | undefined, theme: any) {
    if (buildingType === undefined) 
        return colorsPrimary(theme);

    switch(buildingType) {
        case BuildingType.Office: return colorsAccent(theme);
        case BuildingType.Hotel: return colorsWarning(theme);
        case BuildingType.Educational: return colorsPositiv(theme);
        case BuildingType.ShoppingMall: return colorsPrimary(theme);
        default: return colorsPrimary(theme);
    }
}

const colorsAccent = (theme) => {
    return [
        theme.colors.accent,
        theme.colors.accent100,
        theme.colors.accent200,
        theme.colors.accent300,
        theme.colors.accent400,
        theme.colors.accent500,
        theme.colors.accent600,
        theme.colors.accent700]
}
const colorsPositiv = (theme) => {
    return [
        theme.colors.positive,
        theme.colors.positive100,
        theme.colors.positive200,
        theme.colors.positive300,
        theme.colors.positive400,
        theme.colors.positive500,
        theme.colors.positive600,
        theme.colors.positive700]
}
const colorsWarning = (theme) => {
    return [
        theme.colors.warning,
        theme.colors.warning100,
        theme.colors.warning200,
        theme.colors.warning300,
        theme.colors.warning400,
        theme.colors.warning500,
        theme.colors.warning600,
        theme.colors.warning700]
}
const colorsPrimary = (theme) => {
    return [
        theme.colors.primary,
        theme.colors.primary100,
        theme.colors.primary200,
        theme.colors.primary300,
        theme.colors.primary400,
        theme.colors.primary500,
        theme.colors.primary600,
        theme.colors.primary700]
}



